__turbopack_context__.v({
  "socialAnchor": "VMVULG_socialAnchor",
});
